var menuBar = document.getElementById('menu-bar');
var app = document.getElementById('app');

var heroCtaWaypoint = new Waypoint({
  element: app,
  offset: 150,
  handler: function(direction) {
    if (menuBar.className.indexOf('with-cta') > -1) {
      menuBar.className = menuBar.className.replace(' with-cta', '');
    } else {
      menuBar.className += ' with-cta';
    }
  }
});

var form = document.getElementsByClassName('ajax-form')[0];

if(form) {
  form.addEventListener('submit', submitHandle);
}



/***************/
/*  Functions  */
/***************/

/**
 * Create new Axios object for ajax request
 * @return {object} New axios object
 */
function newAx() {
	return axios.create({
		headers: {
			'X-Requested-With':  'XMLHttpRequest'
		}
	});
}

/**
 * Serialize form data into an array of objects
 * @param  {object} form HTML node for the form to serialize
 * @return {array}  s    Array of objects for each form field, containing name and value
 */
function serializeArray(form) {
  var field, l, s = [];
  if (typeof form == 'object' && form.nodeName == "FORM") {
    var len = form.elements.length;
    for (var i=0; i<len; i++) {
      field = form.elements[i];
      if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
        if (field.type == 'select-multiple') {
          l = form.elements[i].options.length;
          for (j=0; j<l; j++) {
            if(field.options[j].selected)
              s[s.length] = { name: field.name, value: field.options[j].value };
          }
        } else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
          s[s.length] = { name: field.name, value: field.value };
        }
      }
    }
  }
  return s;
}

function submitHandle(e) {

	if ("performance" in window===false)
		return true;

	e.preventDefault();

	var form = this;
	var data = serializeArray(form);
	var msgContainer = document.getElementById('form-message');
	var fieldsContainer = document.getElementById('form-fields');

  // Spam timer
	data[data.length] = {
    name : 'c_time_spam',
    value : performance.now() >= 7000 ? 0 : 1
  };

	var message;
	var ax = newAx();
	var formData = new FormData();


	for(var i=0;i<data.length;i++) {
    formData.append(data[i].name, data[i].value);
  }

	ax.post(form.action, formData)
		 .then(function(r) {
       dataLayerPush(true);

			 scrollIt(document.querySelector('.content-wrapper'), 500, 'linear', function() {
				 msgContainer.innerHTML = r.data.message;
				 msgContainer.className += ' success';
				 fieldsContainer.className += ' hidden';
			 });
		 })
		 .catch(function (e) {
				if (e.response) {
          dataLayerPush(false);

					scrollIt(document.querySelector('.content-wrapper'), 500, 'linear', function() {
						clearErrors(form);
						setErrors(form, e.response.data);
					});
				} else if (e.request) {
					console.log(e.request);
				} else {
					console.log('Error', e.message);
				}
		 });
}

function clearErrors(form) {
	var errors = form.getElementsByClassName('error');
	for(var e=errors.length - 1; e>=0; e--) {
		errors[e].className = errors[e].className.replace(' error', '');
	}
}

function setErrors(form, responseData) {
	var errors = responseData.errors;
	var message = responseData.message;
	var label;

	var msgContainer = document.getElementById('form-message');
	msgContainer.innerHTML = message;
	msgContainer.className += ' error';

    document.querySelector('.g-recaptcha div div').style.border = 'none';
	for(var key in errors) {
        if (key == 'g-recaptcha-response') {
            document.querySelector('.g-recaptcha div div').style.border = '1px solid red';
        }

		label = form.querySelector('label[for="'+key+'"]');
		if(label){
			label.parentNode.className += ' error';
		}
	}
}



// Page Scrolling (from https://pawelgrzybek.com/page-scroll-in-vanilla-javascript/)
function scrollIt(destination, duration = 200, easing = 'linear', callback) {

  const easings = {
    linear(t) {
      return t;
    },
    easeInQuad(t) {
      return t * t;
    },
    easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic(t) {
      return (--t) * t * t + 1;
    },
    easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart(t) {
      return 1 - (--t) * t * t * t;
    },
    easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
    },
    easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint(t) {
      return 1 + (--t) * t * t * t * t;
    },
    easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
    }
  };

  const start = window.pageYOffset;
  const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

  const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
  const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
  const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  function scroll() {
    const now = 'now' in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, ((now - startTime) / duration));
    const timeFunction = easings[easing](time);
    window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

    if (window.pageYOffset === destinationOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }

    requestAnimationFrame(scroll);
  }

  scroll();
}

function dataLayerPush(success) {
  var data = {
    'event': 'FormSubmission',
    'formURI': location.pathname.replaceAll('/', ''),
    'formSuccess': success
  };

  if(typeof dataLayer !== 'undefined')
    dataLayer.push(data);
}